import React, {useState} from 'react'
import { SelectSign } from './SelectSign'
import {Prediction} from './Prediction'
import "./horoscope.css"


const Horoscope = () => {
    const [selectedsign, setSelectedSign] = useState(null)

    const restart = () => {
        setSelectedSign(null)
    }
  return (
    <div className='main'>
      <div className='horContainer'>
        <h1>Today's Horoscope</h1>
        {!selectedsign && <SelectSign onSignSelected={setSelectedSign} />}
        {selectedsign && <Prediction sign={selectedsign} />}
        {selectedsign && <button onClick={restart} className="backBtn">Select Another Sign</button>}
      </div>
        
        
        
    </div>
  )
}

export default Horoscope